import React, { useCallback, useState } from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { deleteVolumeType } from './actions'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Modal from 'core/elements/modal'

export default function DeleteVolumeTypeDialog({ rows: volumeTypes, onClose }) {
  const [error, setError] = useState(null)
  const { update: deleteFn, updating: deletingVolumeItems } = useUpdateAction(deleteVolumeType)

  const volumeTypeNames = volumeTypes
    ?.map((volumeType) => volumeType?.name || volumeType?.id)
    .join(', ')

  const handleDelete = useCallback(async () => {
    setError(null)
    try {
      const results = await Promise.all(
        volumeTypes?.map(async (volumeType) => {
          try {
            const result = await deleteFn(volumeType)
            return { success: true, ...result }
          } catch (error) {
            return {
              success: false,
              error, // store the full error object
            }
          }
        }),
      )

      const allSuccess = results?.every((result) => result.success)

      if (allSuccess) {
        onClose(true)
      } else {
        setError({
          title: 'Error Deleting Volume Type',
          message: results
            ?.filter((r) => !r.success)
            ?.map(
              (r) =>
                r.error?.response?.data?.badRequest?.message ||
                r.error?.response?.data?.message ||
                r.error?.message ||
                'Unknown error',
            )
            ?.join(', '),
        })
      }
    } catch (err) {
      setError({
        title: 'Unexpected Error',
        message: err?.message || 'Something went wrong. Please try again.',
      })
    }
  }, [volumeTypes, deleteFn, onClose])

  return (
    <Modal
      panel="dialog"
      title="Delete Volume Type"
      onClose={onClose}
      open
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingVolumeItems}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingVolumeItems}>
            Confirm
          </Button>
        </>
      }
    >
      <>
        <Text variant="body2">
          You are about to permanently delete the following volume type(s).
        </Text>
        <Text variant="body2">{volumeTypeNames}</Text>
        {!!error && <ErrorMessage>{error.message}</ErrorMessage>}
      </>
    </Modal>
  )
}
